import React from 'react';

const PopupLink = ({href, children, ...props}) => (
  <a {...props} href={href} target="_blank" rel="noopener noreferrer">{children}</a>)

export default PopupLink;
